import Vue from 'vue'
import VueResource from 'vue-resource'
import { getWithDotNotation, hasPermission } from './utils'
import VueTheMask from 'vue-the-mask'
import Toasted from 'vue-toasted'
import store from './store/store'
import config from './config'
import VueOffline from 'vue-offline'
import Cookies from 'js-cookie'

const EndPoint = config.baseUrl
const HerokuEndPoint = config.herokuUrl
const NewHerokuEndPoint = config.newHerokuUrl

Vue.use(VueOffline)
Vue.use(VueTheMask)
Vue.use(Toasted)
Vue.use(VueResource)

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.http.interceptors.push((request, next) => {
  NProgress.start();
  next((response)=>{
    NProgress.done();
  });
});

Vue.http.interceptors.push(function (request, next) {
  const tokenJWTRegex = /^Bearer [A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/
  const getSolarToken = () => {
    const token = Cookies.get('Authorization') ||
    (store && store.state && store.state.accessData && store.state.accessData.solarInfo && store.state.accessData.solarInfo.authorization)

    if (typeof token === 'string' && token.match(tokenJWTRegex)) {
      return token
    }
    return null
  }

  const tokenSolar = getSolarToken()

  if (tokenSolar) {
    request.headers.set('Authorization', tokenSolar)
  } else if (
    request.url.includes('web/login-cognito') ||
    request.url.includes('/web/sso') ||
    request.url.includes('/api/auth-logout')
  ) {
    request.headers.set('X-PontoTel-Authorization', store.state.accessData.cognitoInfo.accessToken)
    request.headers.set('X-PontoTel-UP', store.state.accessData.cognitoInfo.userPoolId)
    request.headers.set('X-PontoTel-DI', store.state.accessData.cognitoInfo.userPoolWebClientId)
  }
  next()
})

// const EndPoint = config.baseUrl + '/api/'

export const API = {
  activate: Vue.resource(EndPoint + '/web/code{/code}'),
  login: Vue.resource(EndPoint + '/api/auth'),
  logout: Vue.resource(EndPoint + '/api/auth-logout'),

  getAuthUserPool: Vue.resource(EndPoint + '/api/auth-user-pool/frontend'),
  company: Vue.resource(EndPoint + '/api/company{/id}'),
  companiesSelected: Vue.resource(EndPoint + '/web/browser{/fingerprint}'), // rootState.fingerprint
  browser: Vue.resource(EndPoint + '/web/browser{/fingerprint}{/compMan}'), // rootState.fingerprint
  checkpwd: Vue.resource(EndPoint + '/web/checkpwd'),
  getTime: Vue.resource(EndPoint + '/web/current-time{/id}'),
  getAccessInfo: Vue.resource(EndPoint + '/web/browser{browserId}'),
  getLoginInfo: Vue.resource(EndPoint + '/web/browsercreate{/fingerprint}'), // rootState.fingerprint
  saveTimeLog: Vue.resource(EndPoint + '/web/savetimelog'),
  webCompany: Vue.resource(EndPoint + '/web/company{/compman}'),
  webCompanyAuth: Vue.resource(EndPoint + '/web/company-auth'),
  get_create: Vue.resource(EndPoint + '/web/ad{/id}/autologin'),
  saveFallback: Vue.resource(HerokuEndPoint + '/api/offline'),
  saveNewFallback: Vue.resource(NewHerokuEndPoint + '/api/offline'),
  register: Vue.resource(EndPoint + '/web/login'), // -> first step of creating a new device
  registerCognito: Vue.resource(EndPoint + '/web/login-cognito'),
  device: Vue.resource(EndPoint + '/web/device{/id}'), // -> api that really creates a new browser record
  ssoDevice: Vue.resource(EndPoint + '/web/sso'), // -> api that creates a new browser record based on a user id
  userFirebaseToken: Vue.resource(EndPoint + '/api/user/firebase-token/employee{/employeeId}'), // -> api to save generated firebase tokens
  webVisual: Vue.resource(EndPoint + '/web/web-visual{/id}'), // -> api that returns the styles and layout
  redirectSSORoute: Vue.resource(EndPoint + '/api/redirect-sso-route{/compManId}'), // -> returns route for logout
  getS3File: Vue.resource('https://lar21css.s3-sa-east-1.amazonaws.com/new-web-version') // -> returns route for logout
}

export const mixins = {
  methods: {
    $getterUseState: (useState) => getWithDotNotation(store.state, useState, '/'),
    $dispatchUseState: (useState, payload) => store.dispatch(useState, payload),
    $commitUseState: (useState, payload) => store.commit(useState, payload)
  }
}

Vue.prototype.$API = API
Vue.prototype.$hasPermission = hasPermission
Vue.mixin(mixins)
